var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fas fa-circle",class:{'text-success': +_vm.score === 1,'text-danger': +_vm.score === -1, 'text-gray-300': _vm.score === null}})
}
var staticRenderFns = []

export { render, staticRenderFns }